import { startTransition, useEffect, useState } from 'react';

/**
 * hydration 이 끝나면 true. 서버와 hydration 첫 렌더는 false 라 둘이 같다.
 *
 * 라우터의 `useHydrated` 를 쓰지 않는다 — useSyncExternalStore 라 hydration 직후 **동기** update 를
 * 만들고, React 18 은 그때 아직 hydration 중인 Suspense 경계를 브라우저 렌더로 갈아엎는다
 * (「This Suspense boundary received an update before it finished hydrating」). 여기선 effect 에서
 * 전환(transition)으로 켜서 hydration 을 끊지 않는다.
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    startTransition(() => setHydrated(true));
  }, []);
  return hydrated;
}
